import { Gap } from '@salecycle/ui-component-library';
import { FC } from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: white;
  flex-direction: column;
  border: none;
  overflow: hidden;
  padding: ${({ theme }) => theme.designToken.spacing1};
`;

const TitleBar = styled.div`
  flex-grow: 1;
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 2px;
`;

const Title = styled.p`
  font: ${({ theme }) => theme.designToken.body2};
  margin: 0;
`;

const Optional = styled.p`
  font: ${({ theme }) => theme.designToken.body2};
  font-style: italic;
  margin: 0;
`;

export interface ConfigurationOptionProps extends IntrinsicProps {
  title?: string;
  optional?: string;
}

export const ConfigurationOption: FC<ConfigurationOptionProps> = ({ title, children, optional, ...props }) => {
  return (
    <Card {...props}>
      <TitleBar>
        <Title>{title}</Title> <Optional>{optional}</Optional>
      </TitleBar>
      {children}
      <Gap bottom={16} />
    </Card>
  );
};
